var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-baseline"},[_c('div',{staticClass:"flex-1 px-4"},[_c('RouterLink',{attrs:{"to":{
        name: 'accounts.contactLists.contactListUuid',
        params: {
          ..._vm.$route.params,
          contactListUuid: _vm.contactList.id,
        },
      }}},[_vm._v(" "+_vm._s(_vm.contactList.name)+" ")])],1),_c('div',{staticClass:"px-4"},[_vm._v(" "+_vm._s(_vm.contactList.activeSubscriptionsCount || 0)+" ")]),_c('div',{staticClass:"px-4"},[(_vm.$membershipHasPermissionTo('edit contact lists,delete contact lists'))?_c('VDropdown',{attrs:{"right":""},scopedSlots:_vm._u([{key:"button",fn:function(dropdownProps){return [_c('button',{staticClass:"btn btn-ghost px-3",on:{"click":dropdownProps.open}},[_c('FontAwesomeIcon',{attrs:{"icon":"ellipsis-v","fixed-width":""}})],1)]}},{key:"default",fn:function(dropdownProps){return [_c('VDropdownMenu',[(_vm.$membershipHasPermissionTo('edit contact lists'))?_c('a',{class:[
              'block',
              'px-4',
              'py-2',
              'hover:bg-gray-200',
              'transition-color',
              'transition-fast',
              'text-right',
            ],attrs:{"role":"button"},on:{"click":function($event){dropdownProps.close(() => _vm.$emit('contact-list-edit', _vm.contactList))}}},[_vm._v("Edit")]):_vm._e(),(_vm.$membershipHasPermissionTo('delete contact lists'))?_c('a',{class:[
              'block',
              'px-4',
              'py-2',
              'hover:bg-gray-200',
              'transition-color',
              'transition-fast',
              'text-right',
            ],attrs:{"role":"button"},on:{"click":function($event){dropdownProps.close(() => _vm.$emit('contact-list-delete', _vm.contactList))}}},[_vm._v("Remove")]):_vm._e()])]}}],null,false,1423013319)}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }